/** Направление взгляда от выбранной ветки: вниз — потомки, вверх — предки, вокруг — соседи на глубине */
export enum EnumLibreDirection {
  DOWN = 'down',
  UP = 'up',
  AROUND = 'around',
}
